import { Color, getDefaultTransition, rwd, Spacing, zIndex } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { FILTER_ACCENT_INVERSION } from '../../styles-deprecated/themes/_common/darkMode'
import { SIDE_NAVBAR_WIDTH } from '../SideNavbar'
import { NavigationVariant } from './types/navigationVariant'
import { getCommonVisibilityStyles } from './utils/getCommonVisibilityStyles'

const MENU_WIDTH = '232px'

const navigationBackgroundColor: Record<NavigationVariant, Color> = {
  default: Color.Grey50,
  inverted: Color.Green950,
}

interface NavigationWrapperProps {
  forceOpen?: boolean
  isMovedToRight?: boolean
  variant: NavigationVariant
}

/* Counter-adjustment of the expert green color in dark mode */
const cancelDarkModeInvertFilter = css`
  .theme-layout-dark & {
    ${FILTER_ACCENT_INVERSION};

    /* avatars already look correct once this subtree's own filter cancels the app-wide invert */
    .react-app-image {
      filter: none;
    }
  }
`

export const NavigationWrapper = styled.aside<NavigationWrapperProps>`
  width: ${MENU_WIDTH};
  height: 100%;
  margin-left: ${({ isMovedToRight }) => (isMovedToRight ? `${SIDE_NAVBAR_WIDTH}` : 'initial')};
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${zIndex.Menu};
  transform: translateX(-${MENU_WIDTH});
  background-color: ${({ variant }) => navigationBackgroundColor[variant]};
  will-change: transform;
  ${getDefaultTransition('transform')};
  ${({ variant }) => variant === 'inverted' && cancelDarkModeInvertFilter};

  ${rwd.greaterThan('xlarge')} {
    transform: translateX(0);
  }

  ${({ forceOpen }) => {
    if (forceOpen) {
      return css`
        transform: translateX(0);
      `
    }
  }};
`

export const NavigationContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: ${Spacing.S8} ${Spacing.S12} ${Spacing.S12};
  overflow: auto;
`

interface VisibilityToggledWrapperProps {
  visible?: boolean
  isMovedToRight?: boolean
}

export const OpenButtonWrapper = styled.div<VisibilityToggledWrapperProps>`
  ${({ visible, isMovedToRight }) => getCommonVisibilityStyles({ visible, isMovedToRight })}

  position: absolute;
  top: ${Spacing.S20};
  left: ${Spacing.S40};
  z-index: ${zIndex.Menu};

  ${rwd.equalOrLessThan('xlarge')} {
    left: ${Spacing.S32};
  }

  ${rwd.equalOrLessThan('tablet')} {
    left: ${Spacing.S16};
  }
`

export const Overlay = styled.div<VisibilityToggledWrapperProps>`
  ${({ visible, isMovedToRight }) => getCommonVisibilityStyles({ visible, isMovedToRight })}

  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${zIndex.MenuOverlay};
  background-color: ${transparentize(0.6, Color.Grey950)};
`
